export function countWords(text: string): number {
  return text.trim().split(/\s+/).filter(Boolean).length;
}

export function limitWords(text: string, maxWords: number): string {
  const words = text.trim().split(/\s+/).filter(Boolean);
  if (!words.length) {
    return '';
  }
  if (words.length <= maxWords) {
    return words.join(' ');
  }
  return `${words.slice(0, maxWords).join(' ')}…`;
}

export function limitSentences(
  text: string,
  maxSentences: number,
  maxWords?: number,
): string {
  const trimmed = text.trim();
  if (!trimmed) {
    return '';
  }
  const sentences =
    trimmed.match(/[^.!?]+[.!?]+|[^.!?]+$/g)?.map((s) => s.trim()).filter(Boolean) ??
    [trimmed];
  let result = sentences.slice(0, maxSentences).join(' ').trim();
  if (maxWords) {
    result = limitWords(result, maxWords);
  }
  return result;
}

export function limitLines(
  text: string,
  maxLines: number,
  maxWords?: number,
): string {
  const lines = text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
  let result = lines.slice(0, maxLines).join('\n').trim();
  if (maxWords) {
    result = limitWords(result, maxWords);
  }
  return result;
}

export function formatDashboardBullets(
  items: unknown[],
  maxItems = 5,
  maxWordsPerItem = 20,
): string[] {
  return items
    .map((item) => limitWords(String(item ?? '').trim(), maxWordsPerItem))
    .filter(Boolean)
    .slice(0, maxItems);
}

export function formatExecutiveSummary(text: string): string {
  const cleaned = text
    .replace(/[•●▪]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!cleaned) {
    return '';
  }
  const sentences = limitSentences(cleaned, 3);
  return limitWords(sentences, 50);
}

export function formatExpertComment(text: string): string {
  return limitLines(limitWords(text, 50), 5);
}
